import React, { useEffect, useState } from "react"

import { FormattedMessage } from "react-intl"
import { Body, ButtonGroup, Modal } from "@walmart-web/livingdesign-components"

import { logout } from "helpers/authUtils"
import Button from "components/Shared/Button"
import { addZeroToTimer } from "helpers/numbers"
import { useApplicationContext } from "context/applicationContext"
import {
	MILISECONDS,
	ONE_SECOND,
	REASON_SESSION_EXPIRED,
	SECONDS,
	SESSION_EXPIRATION,
	WAITING_TIME_TO_EXPIRE,
} from "constants/session"

import "./index.scss"
interface ExpirationMessageProps {
	isOpen: boolean
}

const ExpirationMessageModal: React.FC<ExpirationMessageProps> = ({
	isOpen,
}): JSX.Element => {
	const expirationMoment = new Date()
	const countDownDate = expirationMoment.setMinutes(
		expirationMoment.getMinutes() + WAITING_TIME_TO_EXPIRE
	)

	const { setExpirationMessage, locale } = useApplicationContext()

	const [countDown, setCountDown] = useState("")

	const expireSessionHandler = async () => {
		await logout(true)
	}

	const setTimer = () => {
		const now = new Date()

		const difference = countDownDate - now.getTime()
		const minutes = Math.floor(
			(difference % (MILISECONDS * SECONDS * SECONDS)) / (MILISECONDS * SECONDS)
		)
		const seconds = Math.floor(
			(difference % (MILISECONDS * SECONDS)) / MILISECONDS
		)
		setCountDown(`${addZeroToTimer(minutes)}:${addZeroToTimer(seconds)}`)

		if (minutes <= 0 && seconds <= 0) {
			setExpirationMessage(false)
			sessionStorage.setItem(SESSION_EXPIRATION, REASON_SESSION_EXPIRED)
			expireSessionHandler()
		}
	}

	useEffect(() => {
		if (isOpen) {
			const applyTimer = setInterval(setTimer, ONE_SECOND)
			return () => clearInterval(applyTimer)
		}
		return () => false
	}, [isOpen])

	const keepSessionHandler = () => {
		setExpirationMessage(false)
	}

	const renderButtonsAction = () => {
		return (
			<ButtonGroup className="button-group">
				<Button onClick={expireSessionHandler}>
					<FormattedMessage id="phronesis.usermenu.logout" />
				</Button>
				<Button
					variant="primary"
					onClick={keepSessionHandler}
					data-testid="keep-working-btn"
				>
					<FormattedMessage id="phronesis.session.expiration.keep.session" />
				</Button>
			</ButtonGroup>
		)
	}

	return (
		<Modal
			actions={renderButtonsAction()}
			id="expiration-modal"
			isOpen={isOpen}
			size="small"
			title={<FormattedMessage id="phronesis.session.expiration.title" />}
			onClose={() => false}
			UNSAFE_className="expiration-modal-container"
		>
			<Body as="p">
				<FormattedMessage id="phronesis.session.expiration.first.message" />
			</Body>
			<Body as="p">
				<FormattedMessage id="phronesis.session.expiration.second.message" />
			</Body>
			<p className={locale === "en" ? "timer-container en" : "timer-container"}>
				{countDown}
			</p>
		</Modal>
	)
}

export default ExpirationMessageModal
